/* Theme-level acknowledgement only; checkout/API enforcement requires server validation. */
(() => {
  if (window.ttgOrderAckInstalled) return;
  window.ttgOrderAckInstalled = true;
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[name="checkout"], a[href="/checkout"]')) return;
    if (event.target.closest('#cart-notification-form') && document.querySelector('#cart-notification-product [data-ttg-review-cart]')) {
      event.preventDefault(); event.stopImmediatePropagation(); location.assign(window.routes?.cart_url || (window.Shopify?.routes?.root || '/') + 'cart'); return;
    }
    const box = document.querySelector('[data-ttg-order-ack]');
    if (box && !box.checked) {
      event.preventDefault(); event.stopImmediatePropagation();
      box.reportValidity(); box.focus();
    }
  }, true);
  document.addEventListener('submit', (event) => {
    if (event.target.id !== 'cart') return;
    const box = document.querySelector('[data-ttg-order-ack]');
    if (box && !box.checked && event.submitter?.name === 'checkout') {
      event.preventDefault(); event.stopImmediatePropagation(); box.reportValidity(); box.focus();
    }
  }, true);
})();
